import { isString } from 'lodash';
import { parseISO } from 'date-fns';
import { Haptics, ImpactStyle } from '@capacitor/haptics';

export function uuidv4() {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/gu, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
}

export async function buzz() {
    try {
        await Haptics.impact({ style: ImpactStyle.Medium });
    } catch {
        // this claims to not throw an error, but it does
    }
}

export function dateToYmd(date) {
    if (isString(date) && date.length === 10)
        return date;

    return [
        String(date.getFullYear()).padStart(4, '0'),
        String(date.getMonth() + 1).padStart(2, '0'),
        String(date.getDate()).padStart(2, '0'),
    ].join('-');
}

export function ymdComponents(ymd) {
    return [
        Number(ymd.substr(0, 4)),
        Number(ymd.substr(5, 2)),
        Number(ymd.substr(8, 2)),
    ];
}

export function ymdToDate(ymd) {
    ymd = dateToYmd(ymd);
    return parseISO(ymd);
}

const delays = {};
export function debounceByKey(key, delay, action) {
    clearTimeout(delays[key]);
    delays[key] = setTimeout(action, delay);
}

export function hashcode(string) {
    let hash = 0;
    if (string.length === 0) return hash;
    for (let i = 0; i < string.length; i++)
        hash = (hash << 5) - hash + string.charCodeAt(i) | 0;
    return hash;
}